<template>
  <div v-if="show" class="pc" data-test="predicted-carryover">
    <span class="pc-label">Predicted carryover</span>
    <span class="pc-value">
      <strong>{{ predicted.count }}</strong>
      <span class="pc-sub">tickets · {{ predicted.sp }} SP</span>
    </span>
    <span class="pc-note">non-terminal items remaining at sprint close</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { PredictedCarryover } from "@/api/types";

const props = defineProps<{ predicted?: PredictedCarryover }>();
const predicted = computed(() => props.predicted ?? { count: 0, sp: 0, applicable: false });
const show = computed(() => predicted.value.applicable);
</script>

<style scoped>
.pc {
  background: var(--surface-card, #fff);
  border: 1px solid var(--surface-border, #e5e7eb);
  border-left: 4px solid #d97706;
  border-radius: 8px;
  padding: 10px 14px;
  display: flex; flex-direction: column; gap: 4px;
}
.pc-label { font-size: 11px; color: var(--text-muted, #6b7280); text-transform: uppercase; letter-spacing: 0.04em; }
.pc-value { display: flex; align-items: baseline; gap: 8px; }
.pc-value strong { font-size: 22px; font-weight: 700; color: #b45309; }
.pc-sub { font-size: 12px; color: var(--text-muted, #6b7280); }
.pc-note { font-size: 11px; color: var(--text-muted, #6b7280); }
</style>
